/**
 * Shared rules for user-supplied image uploads. These mirror what the API's
 * multer config in `pulo_api/src/middleware/upload.ts` actually enforces —
 * any `image/*` type up to 10MB — so the client rejects only what the server
 * would reject anyway.
 */
export const ACCEPTED_IMAGE_TYPES = ["image/png", "image/jpeg", "image/jpg"];

/** Value for an <input type="file"> accept attribute. */
export const ACCEPTED_IMAGE_ACCEPT = ACCEPTED_IMAGE_TYPES.join(",");

export const MAX_IMAGE_SIZE_MB = 10;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;

export const isAcceptedImage = (file) =>
  Boolean(file) && ACCEPTED_IMAGE_TYPES.includes(file.type);

/**
 * Returns a user-facing error message, or "" when the file is acceptable.
 */
export const validateImageFile = (file) => {
  if (!file) return "Please select an image.";
  if (!isAcceptedImage(file)) {
    return "Only .jpg, .jpeg and .png files are allowed.";
  }
  if (file.size > MAX_IMAGE_SIZE_BYTES) {
    return `File is too large. Please upload an image under ${MAX_IMAGE_SIZE_MB}MB.`;
  }
  return "";
};
